import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { House } from "lucide-react";
import { IconButton, Divider, Box, Typography, TextField } from "@mui/material";
import { Calendar, Eye, Twitter, User } from "lucide-react";

export default function SignupPage() {
  const [showPassword, setShowPassword] = useState(false);

  const [user, setUser] = useState(null);

  // Fetch user data from the backend (if authenticated)
  useEffect(() => {
    fetch("https://rohan-tax-services.onrender.com/api/auth/dashboard", {
      credentials: "include",
    })
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error("Not authenticated");
      })
      .then((data) => setUser(data))
      .catch(() => setUser(null));
  }, []);

  // Handle Google Login
  const handleGoogleLogin = () => {
    window.location.href =
      "https://rohan-tax-services.onrender.com/api/auth/google";
  };

  return (
    <>
      {!user ? (
        <div className="flex min-h-screen">
          {/* Left Section */}
          <Box
            sx={{
              display: { lg: "flex", xs: "none" },
              width: { xs: "0%", lg: "50%" },
              backgroundImage: `url('https://images.unsplash.com/photo-1570126618953-d437176e8c79?q=80&w=1994&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              flexDirection: "column",
              height: "auto",
            }}
          ></Box>

          {/* Right Section */}
          <Box sx={{ flex: 1, padding: 2 }}>
            <Box sx={{ maxWidth: "24rem", margin: "0 auto" }}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                }}
              >
                {/* Back Button */}
                <a href="/">
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: "1rem",
                      right: 0, // Positioned in the top-right corner
                      backgroundColor: "#E6E6FA",
                      "&:hover": { backgroundColor: "#D8D8F4" },
                    }}
                  >
                    <House />
                  </IconButton>
                </a>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: 1,
                  }}
                >
                  <img
                    src="https://i.pinimg.com/736x/e8/94/ec/e894ec3c62e7aee047b3a8885200aa11.jpg"
                    alt="Rohan's Tax Services Logo"
                    width={200}
                    height={150}
                  />
                </Box>
              </Box>

              <Button
                variant="outlined"
                onClick={handleGoogleLogin}
                fullWidth
                sx={{
                  height: "3rem",
                  textTransform: "none",
                  marginBottom: 2,
                  position: "relative",
                }}
              >
                <Box sx={{ position: "absolute", left: "1rem" }}>
                  <svg className="h-5 w-5" viewBox="0 0 24 24">
                    <path
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                      fill="#4285F4"
                    />
                    <path
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                      fill="#34A853"
                    />
                    <path
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                      fill="#FBBC05"
                    />
                    <path
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                      fill="#EA4335"
                    />
                  </svg>
                </Box>
                Sign in with Google
              </Button>

              <Divider sx={{ marginY: 2 }}>OR</Divider>

              <Box sx={{ marginBottom: 2 }}>
                <TextField label="Name" type="text" fullWidth />
              </Box>

              <Box sx={{ marginBottom: 2 }}>
                <TextField label="Email Address" type="email" fullWidth />
              </Box>

              <Box sx={{ marginBottom: 2 }}>
                <TextField
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        <Eye className="h-5 w-5 text-gray-400" />
                      </IconButton>
                    ),
                  }}
                />
              </Box>

              <Button
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: "#E75480",
                  "&:hover": { backgroundColor: "#D64D7D" },
                  height: "3rem",
                  marginTop: 5,
                  marginBottom: 2,
                }}
              >
                Let&apos;s get started
              </Button>

              <Typography variant="body2" align="center" color="text.secondary">
                Already a member?{" "}
                <a
                  href="#"
                  style={{ color: "#1976d2", textDecoration: "underline" }}
                >
                  Login
                </a>
              </Typography>
            </Box>
          </Box>
        </div>
      ) : (
        <div>
          <h2>Welcome, {user.name}!</h2>
          <p>Email: {user.email}</p>
          <img
            src={user.profilePic}
            alt="Profile"
            style={{ borderRadius: "50%", width: "100px" }}
          />
        </div>
      )}
    </>
  );
}
